import React from 'react';
import { compose, withHandlers } from 'recompose';
import { reduxForm, Field } from 'redux-form';
import Button from '@material-ui/core/Button';
import withStyles from '@material-ui/core/styles/withStyles';
import { TextField } from 'redux-form-material-ui';
import Grid from '@material-ui/core/Grid';
import { withRouter } from 'react-router-dom';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import { Select } from 'redux-form-material-ui';
import { attributeLevel } from '../../../utils/constants';

const styles = (theme) => ({});

const enhance = compose(
  withStyles(styles),
  withRouter,
  withHandlers({}),
  reduxForm({ form: 'addAttributeForm' })
);

export default enhance(({ classes, handleSubmit, setEdit, history, linkBack }) => (
  <form className={classes.form} onSubmit={handleSubmit}>
    <Grid container spacing={24}>
      <Grid item xs={12}>
        <Field name="name" component={TextField} label="Název" />
      </Grid>
      <Grid item xs={12}>
        <Field name="description" component={TextField} label="Popis" />
      </Grid>
      <Grid item xs={12}>
        <FormControl style={{ minWidth: 200 }}>
          <InputLabel htmlFor={'level'}>Příslušnost</InputLabel>
          <Field name={`level`} component={Select} placeholder={'level'}>
            {attributeLevel
              .sort((a, b) => (a.value > b.value) - (a.value < b.value))
              .map((item2) => (
                <MenuItem key={item2.id} value={item2.id}>
                  {item2.label}
                </MenuItem>
              ))}
          </Field>
        </FormControl>
      </Grid>
    </Grid>
    <div style={{ marginTop: 20 }}>
      <Button type="submit" variant="contained" color="primary" className={classes.submit}>
        Uložit
      </Button>
      <Button
        variant="contained"
        color="secondary"
        onClick={() => {
          if (linkBack) {
            setEdit(false);
          } else {
            history.push('/attributes');
          }
        }}
      >
        Zrušit
      </Button>
    </div>
  </form>
));



// WEBPACK FOOTER //
// ./src/modules/attributes/form/addForm.js